<div class="designs-container">
  <h2 i18n>My Designs</h2>
  <mat-card class="card designs-card">
    <mat-card-content>
      <p i18n  class="mat-card-header">DESIGNS</p>
      <div class="content">
        <mat-grid-list [cols]="cols" rowHeight="330px" (window:resize)="onResize($event)">
          <mat-grid-tile *ngFor="let design of designs" style="padding: 10px;">
            <mat-card class="card design-card">
              <mat-card-content>
                <p i18n  class="mat-card-header">{{design.data.design_name}} <span style="float:right"><i (click)="deleteDesign(design.id)" class="fa-solid fa-trash-can"></i></span></p>
                <div class="design">
                  <img [src]="design.img" alt="myDesign" class="design-img">
                  <p i18n  >{{design.data.saved.toDate() | date}}</p>
                  <p i18n  class="view-more" (click)="goToDesign(design.data,design.id)">View more <mat-icon
                      class="arrow-icon">keyboard_arrow_right</mat-icon>
                  </p>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-grid-tile>
        </mat-grid-list>
      </div>

    </mat-card-content>
  </mat-card>
  <mat-card class="card designs-card">
    <mat-card-content>
      <p i18n  class="mat-card-header">DELETED DESIGNS</p>
      <div class="content">
        <mat-grid-list [cols]="cols" rowHeight="330px" (window:resize)="onResize($event)">
          <mat-grid-tile *ngFor="let design of deletedDesigns" style="padding: 10px;">
            <mat-card class="card design-card">
              <mat-card-content>
                <p i18n  class="mat-card-header">{{design.data.design_name}}</p>
                <div class="design">
                  <img [src]="design.img" alt="myDesign" class="design-img">
                  <p i18n  >{{design.data.saved.toDate() | date}}</p>
                  <p i18n  class="view-more" (click)="restoreDesign(design.id,design.data)">Restore <mat-icon
                      class="arrow-icon">keyboard_arrow_right</mat-icon>
                  </p>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-grid-tile>
        </mat-grid-list>
      </div>

    </mat-card-content>
  </mat-card>
</div>